// test1567
(1567 && 0);
